import 'material-design-icons-iconfont/dist/material-design-icons.css'

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import en from '@/lang/en'
import th from '@/lang/th'

// Your own translation file
Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#D76436',
                secondary: '#b0bec5',
                anchor: '#8c9eff'
            }
        }
    },
    lang: {
        locales: { th, en },
        current: 'en'
    }
})
